// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Title-module--cls1--3tmVt","cls2":"styles-Title-module--cls2--2EPP- styles-Title-module--cls1--3tmVt"};